import {useMemo} from 'react';
import {FontItem} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/FontItem/FontItem';
import {
  Font,
  WindowFont,
} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/types';
import {useRecentlyUsedFonts} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {getFontName, getFontWeight} from '../utils';

type RecentlyUsedFontsProps = {
  onClick: (font: Font) => void;
  selectedFont?: Font;
};

export const RecentlyUsedFonts = ({onClick, selectedFont}: RecentlyUsedFontsProps) => {
  const {recentlyUsedFonts} = useRecentlyUsedFonts();
  const fonts: Font[] = useMemo(() => {
    const recentFonts = [];
    for (const recentlyUsedFont of recentlyUsedFonts) {
      const windowFonts = (window as Window & {fonts?: WindowFont[]}).fonts ?? [];
      for (const font of windowFonts) {
        if (
          recentlyUsedFont &&
          font &&
          recentlyUsedFont.family === font.family &&
          recentlyUsedFont.style &&
          font.styles?.includes(recentlyUsedFont.style)
        ) {
          const weight =
            recentlyUsedFont.weight !== undefined && font.weights?.includes(recentlyUsedFont.weight)
              ? recentlyUsedFont.weight
              : getFontWeight(recentlyUsedFont.weight);

          const name = getFontName(font, recentlyUsedFont.style, weight);

          recentFonts.push({
            name,
            family: font.family,
            style: recentlyUsedFont.style,
            weight: recentlyUsedFont.weight,
            type: font.type,
          });
        }
      }
    }
    return recentFonts;
  }, [recentlyUsedFonts]);

  return (
    <div className="fonts__mobile--recent">
      {fonts.map((option, index) => (
        <FontItem
          font={option}
          key={`${option.name}_${index}`}
          onClick={onClick}
          selected={option.name === selectedFont?.name}
          isRecentlyUsedFonts={true}
        />
      ))}
    </div>
  );
};
